module.exports = __webpack_public_path__ + "img/bell-blue.f0894ceb.svg";